// This icon file is generated automatically.
var PLogoutOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.56 10.44h-1.1a.25.25 0 00-.19.09 5.53 5.53 0 110-7.06c.05.06.12.1.2.1h1.1c.1 0 .15-.12.1-.2a6.72 6.72 0 100 7.26c.05-.08 0-.2-.1-.2zm1.4-3.54l-2.23-1.75a.13.13 0 00-.2.1v1.19h-4.9a.13.13 0 00-.13.12v.88c0 .07.06.12.13.12h4.9v1.19c0 .1.12.16.2.1l2.22-1.75a.12.12 0 000-.2z", "fill-rule": "nonzero" } }] }, "name": "p-logout", "theme": "outlined" };
export default PLogoutOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLogoutOutlined.js
// module id = 3503
// module chunks = 0